import axios from 'axios';
import { ContactGroups, Contacts } from '../models';

const state = {
  data: new Contacts(),
  contactGroups: null,
};

const getters = {};

const actions = {
  async fetchContactGroups({ rootGetters, commit }) {
    try {
      const response = await axios.get(rootGetters.api.contactsGroups());
      commit('SAVE_CONTACT_GROUPS', response.data);
    } catch (e) {
      commit('ADD_ERROR', e.message);
    }
  },
  async fetchContacts({ rootGetters, commit }) {
    try {
      const response = await axios.get(rootGetters.api.contacts());
      commit('SAVE_CONTACTS', response.data);
    } catch (e) {
      commit('ADD_ERROR', e.message);
    }
  },
  async addContact({ rootGetters, commit, dispatch }, data) {
    try {
      const response = await axios.post(rootGetters.api.contacts(), data);
      response.data.entry.photo = data.photo;
      commit('ADD_CONTACT', response.data);
      const photo = {
        id: response.data.entry.id.$t.split('/').pop(),
        photo: data.photo,
      };
      dispatch('updatePhoto', photo);
    } catch (e) {
      commit('ADD_ERROR', e.message);
    }
  },
  async updateContact({ state, rootState, rootGetters, dispatch, commit }, data) {
    try {
      const payload = data;
      payload.meta = {
        email: rootState.user.email,
        etag: state.data.etag,
        updated_at: (new Date()).toJSON(),
      };
      const response = await axios.put(rootGetters.api.contacts(), payload);
      commit('DELETE_CONTACT', data);
      response.data.entry.photo = data.photo;
      commit('ADD_CONTACT', response.data);
      await dispatch('updatePhoto', data);
    } catch (e) {
      commit('ADD_ERROR', e.message);
    }
  },
  deleteContact({ rootGetters, commit }, item) {
    commit('DELETE_CONTACT', item);
    try {
      axios.delete(rootGetters.api.contacts(), { headers: { id: item.id } });
    } catch (e) {
      commit('ADD_ERROR', e.message);
    }
  },
  async updatePhoto({ rootGetters }, data) {
    if (data.photo) {
      const index = data.photo.indexOf(',');
      const photo = data.photo.substring(index + 1);
      await axios.put(rootGetters.api.contactPhoto(), photo, { headers: { id: data.id } });
    }
  },
  async deleteContactPhoto({ rootGetters }, data) {
    await axios.delete(rootGetters.api.contactPhoto(), { headers: { id: data.id } });
  },
};

const mutations = {
  SAVE_CONTACTS(state, payload) {
    state.data = new Contacts(payload, state.contactGroups);
  },
  ADD_CONTACT(state, payload) {
    state.data.addContact(payload.entry, state.contactGroups);
  },
  UPDATE_CONTACT(state, payload) {
    state.data.updateContact(payload);
  },
  DELETE_CONTACT(state, payload) {
    state.data.deleteContact(payload);
  },
  SAVE_CONTACT_GROUPS(state, payload) {
    state.contactGroups = new ContactGroups(payload);
  },
  CLEAR_CONTACT_ENTRIES(state) {
    state.data = new Contacts();
  },
  CLEAR_CONTACTS(state) {
    state.data = new Contacts();
    state.contactGroups = null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js